import get from 'lodash.get';
import { config } from '@yola/ws-sdk';

const getWonderChatId = (state) => {
  const cfg = config.selectors.getConfig(state);

  return get(cfg, 'common.wonderchat.id', '');
};

export default getWonderChatId;
